import React from 'react';
import { baseUrl, domain, partyBrands } from '../../common/config.js';
import { connect } from 'react-redux';
import { saveActivity } from '../../common/commonService'
import { apiService, axiosCallService } from '../../common/apiCallService';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';
import * as actions from '../../store/actions/index';
import {
    DEFAULT_STATE,
    IMAGES_ARRAY, QuizPositions, AnswerOptionsComp, AVG_SCORE, BAD_SCORE,
    TROPHY, QUIZ_ANSWER_IMAGES, LOADER, getQuizSubTypeComp,
    getQuizScenarios, getQuizTypeComp, FlopCards, viewScenariosIntro,
    LEVEL_1, LEVEL_2, LEVEL_3, LEVEL_4
} from './QuickQuizHelper';

import { QUIZ_RESULT, QUIZ_COMMON_MESSAGES_BY_TYPE, QUIZ_ANSWER_MESSAGES } from './QuizMessages';
import { getColor, getTextColor } from '../../common/ThemeService.js';

class QuickQuiz extends React.Component {

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE
    }
    componentDidMount() {
        this.cacheInitialImages();
        window.addEventListener('unload', this.handleClose.bind(this))
    }
    cacheInitialImages = () => {
        IMAGES_ARRAY.map((src) => {
            const img = new Image();
            img.src = "//" + domain + "/images/pokerQuiz/" + src;
            img.onload = () => true;
            return img;
        })
    }

    getQuestionsByPositions = (positionNumber) => {
        let facingRaiserPosition;
        if (this.state.facingPositionNumber) {
            let filterArray = this.state.facingPositionNumber.filter((item) => {
                return item.positions === positionNumber
            })
            if (filterArray && filterArray.length > 0) {
                facingRaiserPosition = filterArray[Math.floor(Math.random() * filterArray.length)].raiserPosition;
            }
        }

        apiService(baseUrl + '/quiz/getQuestionsByPosition', {
            quizId: this.state.currentQuiz._id,
            positionNumber: positionNumber, noOfQuestions: 2, facingRaiserPosition, attemptedIds: Object.keys(this.state.quizResults)
        }, res => {
            const combinedQuestions = this.state.questions.concat(res);
            this.setState({
                questionsLoaded: true,
                questions: combinedQuestions,
                heroPosition: combinedQuestions[this.state.currentQuestionIndex].positionNumber,
                facingRaiserPosition: combinedQuestions[this.state.currentQuestionIndex].facingRaiserPosition,
                cards: this.string_chop(combinedQuestions[this.state.currentQuestionIndex].hand, 2),
                flopCards: combinedQuestions[this.state.currentQuestionIndex].flopCards ? this.string_chop(combinedQuestions[this.state.currentQuestionIndex].flopCards, 2) : undefined,
                potSize: combinedQuestions[this.state.currentQuestionIndex].potSize,
                betSize: combinedQuestions[this.state.currentQuestionIndex].betsize ? combinedQuestions[this.state.currentQuestionIndex].betsize.toString().split("bb")[0] : undefined,
                bb: combinedQuestions[this.state.currentQuestionIndex].bb
            });
        }, err => {
            console.log(err);
        })
    }


    startQuiz = async () => {
        try {
            let positionArray = [0, 0, 0, 0, 0];
            if (this.state.currentQuiz.positions.length === 1) {
                positionArray.fill(this.state.currentQuiz.positions[0])
            } else {
                positionArray = this.state.currentQuiz.positions.length > 1 ? await this.shuffle(this.state.currentQuiz.positions) : [];
                if (positionArray.length * 2 < this.state.currentQuiz.noOfQuestions) {
                    let remaingLength = this.state.currentQuiz.noOfQuestions -positionArray.length * 2;
                    let shuffleData = await this.shuffle(positionArray);
                    positionArray.push(...shuffleData.slice(shuffleData.length-remaingLength/2))
                }
            }
            positionArray = positionArray.slice(0, this.state.currentQuiz.noOfQuestions / 2);
            this.getQuestionsByPositions(positionArray[0]);
            let cmMessage = QUIZ_COMMON_MESSAGES_BY_TYPE[this.state.currentQuiz.type][positionArray[0]];
            let commonMessages = cmMessage[Math.floor(Math.random() * (cmMessage.length >= 3 ? 3 : cmMessage.length))]
            let track = {}
            track.hit_page = 'Quiz';
            track.hit_type = "Start";
            track.hit_attribute1 = this.state.currentQuiz ? this.state.currentQuiz.name : "NA";
            saveActivity(track);
            this.setState({
                page: 'onQuiz',
                positionNumber: positionArray,
                commonMessage: commonMessages,
                quizSubmitStatus: false,
                quizResults: {}
            });
        } catch (err) {
            console.log('error in start quiz', err)
        }
    }
    shuffle = async (array) => {
        let index = array.findIndex((item) => item === 9);
        if (index !== -1) {
            array.splice(index, 1);
            array.sort(() => [Math.random() - 0.5]);
            array.push(9);
            return array;
        }
        return array.sort(() => Math.random() - 0.5);
    }
    string_chop = (str, size) => {
        if (str == null) return [];
        str = String(str);
        size = ~~size;
        return size > 0 ? str.match(new RegExp('.{1,' + size + '}', 'g')) : [str];
    }
    saveQuizResults = () => {
        apiService(baseUrl + '/quiz/saveQuizResults', { meta: this.state.currentQuiz, answers: this.state.quizResults }, res => {
            this.setState({ quizSubmitStatus: true });
        }, err => {
            console.log(err);
        })
    }
    onAnswerClick = (type, questionId) => {
        let questions = this.state.questions[this.state.currentQuestionIndex];
        let cmMessage = [];
        let commonMessages = {};
        if (type === 'call' && questions.callOrNot === 2) {
            cmMessage = QUIZ_ANSWER_MESSAGES['call']
            commonMessages = cmMessage[Math.floor(Math.random() * cmMessage.length)]
            this.setState({
                call: true,
                commonMessage: commonMessages,
                callImage: QUIZ_ANSWER_IMAGES.call.red
            })
        } else {
            let { callImage, foldImage, raiseImage } = this.state;
            let isAnswerCorrect = 0;
            let cssClassName = 'negative_fold';
            if (type === 'call') {
                isAnswerCorrect = questions.callOrNot === 1;
                callImage = isAnswerCorrect ? QUIZ_ANSWER_IMAGES.call.green : QUIZ_ANSWER_IMAGES.call.red;
                cssClassName = 'call';
            } else if (type === 'raise') {
                isAnswerCorrect = questions.raisOrNot === 1;
                raiseImage = isAnswerCorrect ? QUIZ_ANSWER_IMAGES.raise.green : QUIZ_ANSWER_IMAGES.raise.red;
                cssClassName = 'negative_raise';
            } else {
                isAnswerCorrect = questions.foldOrNot === 1;
                foldImage = isAnswerCorrect ? QUIZ_ANSWER_IMAGES.fold.green : QUIZ_ANSWER_IMAGES.fold.red;
            }
            if (!isAnswerCorrect) {
                callImage = questions.callOrNot === 1 ? QUIZ_ANSWER_IMAGES.call.green : QUIZ_ANSWER_IMAGES.call.red
                foldImage = questions.foldOrNot === 1 ? QUIZ_ANSWER_IMAGES.fold.green : QUIZ_ANSWER_IMAGES.fold.red
                raiseImage = questions.raisOrNot === 1 ? QUIZ_ANSWER_IMAGES.raise.green : QUIZ_ANSWER_IMAGES.raise.red
            }
            let resultMap = this.state.quizResults;
            resultMap[questions._id] = type;
            cmMessage = QUIZ_ANSWER_MESSAGES[isAnswerCorrect ? 'possitive' : (!isAnswerCorrect && cssClassName)]
            commonMessages = cmMessage[Math.floor(Math.random() * cmMessage.length)]
            this.setState({
                correctlyAnsCount: this.state.correctlyAnsCount + isAnswerCorrect,
                attemptedCount: this.state.attemptedCount + 1,
                status: isAnswerCorrect,
                commonMessage: commonMessages,
                clickOn: type,
                cards: [],
                quizResults: resultMap,
                call: false,
                callImage,
                foldImage,
                raiseImage
            })
        }
    }
    onNext = () => {
        let currentIndex = this.state.currentQuestionIndex;
        let status = false;
        if (currentIndex % 2 === 0 && (currentIndex) / 2 + 1 < this.state.positionNumber.length) {
            this.getQuestionsByPositions(this.state.positionNumber[(currentIndex) / 2 + 1]);
            status = true;
        }
        if (currentIndex + 1 < this.state.currentQuiz.noOfQuestions) {
            if (!status) {
                this.setState({
                    heroPosition: this.state.questions[currentIndex + 1].positionNumber,
                    facingRaiserPosition: this.state.questions[currentIndex + 1].facingRaiserPosition,
                    cards: this.string_chop(this.state.questions[currentIndex + 1].hand, 2)
                })
            }
            let cmMessage = QUIZ_COMMON_MESSAGES_BY_TYPE[this.state.currentQuiz.type][(currentIndex + 1 === this.state.currentQuiz.noOfQuestions - 1) ? 'last' : this.state.questions[currentIndex + 1].positionNumber]
            let commonMessages = cmMessage[Math.floor(Math.random() * cmMessage.length)]
            this.setState({
                commonMessage: commonMessages,
                currentQuestionIndex: currentIndex + 1,
                status: 2,
                clickOn: 'none',
                card1Loading: true,
                card2Loading: true,
                foldImage: QUIZ_ANSWER_IMAGES.fold.gray,
                raiseImage: QUIZ_ANSWER_IMAGES.raise.gray,
                callImage: QUIZ_ANSWER_IMAGES.call.gray
            })
        } else {            
            console.log("current quiz type...."+ JSON.stringify(this.state.currentQuiz));            
            let cmMessage;            
            let correctAnsCount = this.state.correctlyAnsCount
            if(correctAnsCount>=0 && correctAnsCount<=3){
                cmMessage = QUIZ_RESULT['level1'][0];
            } else if(correctAnsCount>=4 && correctAnsCount<=6){
                cmMessage = QUIZ_RESULT['level2'][0];
            } else if(correctAnsCount>=7 && correctAnsCount<=8){
                cmMessage = QUIZ_RESULT['level3'][0];
            } else if(correctAnsCount===9){
                cmMessage = QUIZ_RESULT['level4'][0];
            } else if(correctAnsCount===10 && this.state.currentQuiz.name === 'Preflop'){
                cmMessage = QUIZ_RESULT['level5PreFlop'][0];
            } else{
                cmMessage = QUIZ_RESULT['level5PostFlop'][0];
            }
            this.setState({
                commonMessage: cmMessage,
                page: 'result',
                currentQuestionIndex: 0,
                status: 2,
                clickOn: 'none',
                cards: []
            })
            this.saveQuizResults();
        }

    }
    goToPrevScenario = () => {
        let { currentQuiz, quizScenarioSteps, stepCount } = this.state;
        clearInterval(this.state.intervalId);
        if (stepCount > 0) {

            let steps = currentQuiz.quizScenario.steps[stepCount];
            delete quizScenarioSteps[steps.key];
            this.setState({
                quizScenarioSteps: quizScenarioSteps,
                stepCount: stepCount - 1
            })
        }
        this.setState({
            intervalId: ''
        })
    }
    goToNextScenario = () => {
        let { currentQuiz, quizScenarioSteps, stepCount } = this.state;
        if (stepCount !== currentQuiz.quizScenario.steps.length - 1) {
            let steps = currentQuiz.quizScenario.steps[stepCount];
            quizScenarioSteps[steps.key] = steps;
            this.setState({
                quizScenarioSteps: quizScenarioSteps,
                stepCount: stepCount + 1
            })
        } else {
            clearInterval(this.state.intervalId);
            this.setState({
                intervalId: '',
                page: 'intro',
                quizScenarioSteps: {},
                stepCount: 0
            })
        }

    }
    playScenario = (item) => {
        let intervalId = setInterval(this.goToNextScenario, 2000);
        this.setState({
            page: 'quizScenarios',
            quizScenarioSteps: {},
            stepCount: 0,
            intervalId: intervalId
        });

    }
    getQuizSubTypes = () => {
        this.setState({
            page: 'quizSubType'
        })
    }

    getQuizes = (item) => {
        axiosCallService('/quiz/getQuiz', { quizTypeId: item._id }).then(res => {
            if (res.data && res.data.meta) {
                this.props.loadQuizDetails(res.data);
            }
            else {
                this.setState({
                    page: 'errorPage'
                })
            }
        }).catch(err => {
            console.log(err);
            this.setState({
                page: 'errorPage'
            })
        });
        this.setState({
            page: 'quizSubTypes',
            currentQuizType: item
        })
    }
    goBack = (pageName) => {
        clearInterval(this.state.intervalId);
        if (pageName === 'quizTypes') {
            this.props.loadQuizDetails([]);
        }
        this.setState({
            page: pageName
        })
    }

    getElements = () => {
        let elems = [];
        const commonMessage = this.state.commonMessage;
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        switch (this.state.page) {
            case 'viewScenarios':
                elems = viewScenariosIntro({
                    goBack: this.goBack,
                    playScenario: this.playScenario, type: this.state.currentQuiz.type,
                    description: this.state.currentQuiz.description,
                    startQuiz: this.startQuiz,
                    currentQuiz:this.state.currentQuiz
                });
                break;
            case 'quizScenarios':
                elems = getQuizScenarios({
                    quizScenarios: this.state.currentQuiz.quizScenario,
                    stepsCompleted: this.state.quizScenarioSteps,
                    currentStep: this.state.stepCount,
                    goToNextScenario: this.goToNextScenario,
                    goToPrevScenario: this.goToPrevScenario,
                    goBack: this.goBack
                });
                break;
            case 'quizTypes':
                elems = getQuizTypeComp({ quizDetails: this.props.allQuizDetails, getQuizes: this.getQuizes })
                break;
            case 'quizSubTypes':
                elems = getQuizSubTypeComp({
                    quizDetails: this.props.quizDetails,
                    currentQuizType: this.state.currentQuizType, playQuiz: this.playQuiz, goBack: this.goBack
                });
                break;
            case 'intro':
                elems.push(<i key="viewScenarioGoback" className="fa fa-lg fa-long-arrow-left cursor-pointer quiz-back-button"
                    data-e2e="back-button" style={{ fontSize: "24px", position: 'absolute', color: themeColor, left: '20px' }}
                    onClick={() => this.goBack('quizSubTypes')}
                ></i>);
                elems.push(<img className="quiz-img" key="quiz-img" alt="SmileFlickingCapUp" src={"//" + domain +(partyBrands.includes(localStorage.getItem("loggedInType"))? "/images/pokerQuiz/SmileFlickingCapUp.gif":"/images/pokerQuiz/SmileFlickingCapUp_generic.gif")}></img>);
                elems.push(<div className="title" key="quiz-intro-title">It's Game Time {localStorage.getItem('first_name').replace(/(\w)(\w*)/g,
                    function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })}</div>)
                elems.push(<div className="description" key="quiz-intro-description">This {this.state.currentQuiz.type} quiz will help take your game to the next level!</div>)
                elems.push(<button className="partyPokerPlayBtn quiz-button" key="quiz-intro-play-button" onClick={this.startQuiz}
                    style={{
                        backgroundColor: themeColor,
                        color: themeTextColor,
                        borderColor: themeColor,
                    }}
                >
                    <span data-e2e="lets-play">
                        LETS PLAY!
                    </span>
                </button>)
                {
                    this.state.currentQuiz.isQuizScenario && elems.push(<button className="replayButton"
                        data-e2e="replay-scenario" onClick={this.playScenario}>
                        <span >
                            Replay Scenario
                     </span>
                    </button>)
                }
                break;
            case 'onQuiz':
                if (this.state.questionsLoaded) {
                    elems.push(<div className="quiz-table-div" key ="quiz-table-div"
                        style={{ backgroundImage: `url(https://${domain}/images/pokerQuiz/table.png)` }}>
                        <QuizPositions heroPosition={this.state.heroPosition}
                            facingRaiserPosition={this.state.facingRaiserPosition}
                            betSize={this.state.betSize * (this.state.bb ? this.state.bb : 1)}
                            bb={this.state.bb} />
                        <AnswerOptionsComp
                            bb={this.state.bb}
                            callImage={this.state.callImage}
                            raiseImage={this.state.raiseImage}
                            foldImage={this.state.foldImage}
                            heroPosition={this.state.heroPosition}
                            clickOn={this.state.clickOn}
                            status={this.state.status}
                            cards={this.state.cards}
                            call={this.state.call}
                            question={this.state.questions[this.state.heroPosition]}
                            card1Loading={this.state.card1Loading}
                            card2Loading={this.state.card2Loading}
                            onAnswerClick={this.onAnswerClick}
                            onNext={this.onNext}
                            onLoad={(index) => {
                                this.setState({
                                    [index === 0 ? 'card1Loading' : 'card2Loading']: false
                                })
                            }}
                        />
                    </div>)
                    elems.push(<div className="quiz-bottom" key="quiz-bottom">
                        <img alt="whizOkOrBroken" src={"//" + domain + (this.state.call || this.state.status === 0 ? "/images/pokerQuiz/broken.png" : "/images/pokerQuiz/whiz_ok.png")}></img>
                        <div>
                            <span >{commonMessage.p1.replace("FIRST_NAME", localStorage.getItem('first_name'))}</span>
                            {commonMessage.p2 && <span style={{ fontWeight: '500' }}>{commonMessage.p2.replace("FIRST_NAME", localStorage.getItem('first_name'))}</span>}
                            {/* {this.state.status ===2 && !this.state.call && 
                            <span style={{fontWeight:'500',marginTop:commonMessage.p2?'0px':'15px'}}>{`${this.state.currentQuestionIndex + 1} of ${this.state.currentQuiz.noOfQuestions}`}</span>} */}
                            {this.state.status === 2 && !this.state.call &&
                                <span style={{ fontWeight: '500', marginTop: '0px' }}>{`${this.state.currentQuestionIndex + 1} of ${this.state.currentQuiz.noOfQuestions}`}</span>}
                        </div>
                    </div>)
                    if (this.state.flopCards) {
                        elems.push(<FlopCards cards={this.state.flopCards} value={this.state.potSize * (this.state.bb ? this.state.bb : 1)} />)
                    }
                } else {
                    elems.push(<div className="quiz-table-div" key="quiz-table-div-loader"
                        style={{ backgroundImage: `url(https://${domain}/images/pokerQuiz/table.png)` }}>
                        {LOADER()}
                    </div>)
                }
                break;
            case 'result':
                let imageName;            
                let correctAnsCountForImage = this.state.correctlyAnsCount
                if(correctAnsCountForImage>=0 && correctAnsCountForImage<=3){
                    imageName=LEVEL_1;
                } else if(correctAnsCountForImage>=4 && correctAnsCountForImage<=6){
                    imageName=LEVEL_2;
                } else if(correctAnsCountForImage>=7 && correctAnsCountForImage<=8){
                    imageName=LEVEL_3;
                } else{
                    imageName=LEVEL_4;
                }
                elems.push(<div className="quiz-header" key="quiz-result-header">
                    {this.state.correctlyAnsCount === 'undefined' ? '--' : this.state.correctlyAnsCount}/{this.state.currentQuiz.noOfQuestions === 'undefined' ? '--' : this.state.currentQuiz.noOfQuestions}
                </div>)
                elems.push(<img className="quiz-result-img"  key="quiz-result-img" alt="resultImg" src={"//" + domain + imageName}></img>);
                elems.push(<div className="title" key="quiz-result-title">{commonMessage.p1.replace("FIRST_NAME", localStorage.getItem('first_name'))}</div>)
                elems.push(<div className="description" key="quiz-result-description">{commonMessage.p2.replace("FIRST_NAME", localStorage.getItem('first_name'))}</div>)
                elems.push(<div className="description" key="quiz-result-subdescription">Have a look at these starting hand charts to learn more about this key topic.</div>)
                elems.push(<button className="partyPokerPlayBtn quiz-button quiz-reult-btn" key="quiz-result-btn" data-dismiss="modal" onClick={e => {
                    let track = {}
                    track.hit_page = 'Quiz';
                    track.hit_type = "Completed_LearnMore";
                    track.hit_attribute1 = this.state.currentQuiz ? this.state.currentQuiz.name : "NA";
                    track.hit_attribute2 = this.state.correctlyAnsCount;
                    saveActivity(track);
                    localStorage.setItem('play', 'ideal');
                    window.location.reload()
                }}
                    style={{
                        backgroundColor: themeColor,
                        color: themeTextColor,
                        borderColor: themeColor,
                    }}
                >
                    <span data-e2e="meet whiz"
                        style={{
                            backgroundColor: themeColor,
                            color: themeTextColor,
                        }}
                    >
                        LEARN ABOUT STARTING HANDS
                    </span>
                </button>);
                elems.push(<div className="quiz-result-link" key="quiz-result-lnk" data-dismiss="modal" onClick={this.handleClose}>No, Thanks</div>);
                break;
            case 'errorPage':
                elems.push(<div key="error-page">
                    <img className="quiz-result-img" src={"//" + domain + BAD_SCORE} alt="badScore"></img>
                    <div style={{ color: 'red' }}>Something went wrong</div>
                </div>);

                break;
            default:
                break;
        }
        return elems;
    }

    playQuiz = (quiz) => {
        this.setState({
            page: quiz.isQuizScenario ? 'viewScenarios' : 'intro',
            currentQuiz: quiz,
            facingPositionNumber: quiz.facingPosition,

        })
    }
    handleClose = () => {
        clearInterval(this.state.intervalId);
        if (!this.state.quizSubmitStatus && this.state.attemptedCount > 0) {
            this.saveQuizResults();
        }
        let track = {}
        track.hit_page = 'Quiz';
        if (this.state.attemptedCount < 10) {
            track.hit_type = "Exit";
            track.hit_attribute2 = this.state.attemptedCount + 1;
        } else {
            track.hit_type = "Completed_Exit";
            track.hit_attribute2 = this.state.correctlyAnsCount;
        }
        track.hit_attribute1 = this.state.currentQuiz ? this.state.currentQuiz.name : "NA";
        saveActivity(track);
        this.setState({
            ...DEFAULT_STATE
        })
    }

    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        let contentClass = '';
        if (this.state.page === 'quizTypes') {
            contentClass = 'quiz_type_page_content'
        }
        return <div id="quizModal" className="modal fade quiz_modal" role="dialog" data-backdrop="static">
            <style>
                {`\
                    .replayButton:hover {\
                        background-color: ${themeColor};\
                        color: ${themeTextColor};\
                    }\
                `}
            </style>
                <div className="modal-dialog quiz_modal_dialog">
                    <div ref={element => {
                        this.quizPage = element;
                    }} className={"modal-content quiz_modal_content " + contentClass} style={this.state.page === 'onQuiz' ? { padding: '2px 15px', paddingBottom: '5px' } : {}}  >
                        {/* {this.state.page !== 'quizTypes' && this.state.page !== 'onQuiz' ? <div className="quiz_back-button">
                            <i className="fa fa-lg fa-long-arrow-left cursor-pointer" data-dismiss="modal" data-e2e="close" style={{ fontSize: "18px" }}></i>
                        </div> : null} */}
                        <div className="learnMore_close_button" onClick={this.handleClose}>
                            <i className="fa fa-lg fa-times cursor-pointer" data-dismiss="modal" data-e2e="close" style={{ fontSize: "18px" }}></i>
                        </div>
                        {this.getElements()}

                    </div>
                </div>
        </div>
    }
}

const mapStateToProps = (state) => ({
    quizDetails: state.commonReducer.quizDetails,
    allQuizDetails: state.commonReducer.allQuizDetails
})
const mapDispatchToProps = dispatch => {
    return {
        loadQuizDetails: (quiz) => dispatch(actions.loadQuizDetails(quiz))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickQuiz);


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/QuickQuiz.js
 **/